module.exports = __webpack_public_path__ + "static/img/mypage-navigation-menu02.781b76e7.svg";